import { onLogout } from 'helpers';

const Logout = () => onLogout();

export default Logout;
